<template>
  <div
    ref="insuranceType"
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--between">
        <span>פרטי גורם משלם ומבטח**</span>
        <Tags :isRequired="true" />
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>

    <div v-show="isOpen" class="book_surgery_open toggleInner">
      <div
        class="inner_group bg--white desk-no-pad desk-flex desk-flex--top desk-flex--start"
      >
        <!-- Is Insured by Company -->
        <div class="add_new_row flex">
          <div class="add_new_row_col1">האם מבוטח בחברת ביטוח?*</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <validation-provider
                name="isInsuranceCompany"
                rules="required"
                v-slot="{ errors }"
              >
                <select2 dir="rtl" v-model="surgery.isInsuranceCompany">
                  <option
                    v-for="option in insuranceQuestions.booleanOptions"
                    :key="option.text"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select2>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>

        <!-- Health Care Provider -->
        <div class="add_new_row flex">
          <div class="add_new_row_col1">באיזו קופת חולים מבוטח המטופל?*</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <validation-provider
                name="insurance_type"
                rules="required"
                v-slot="{ errors }"
              >
                <select2 dir="rtl" v-model="surgery.insurance_type">
                  <option
                    v-for="option in insuranceQuestions.careServicesOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select2>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>

        <!-- Pay Type -->
        <div class="add_new_row flex">
          <div class="add_new_row_col1">איזה גורם משלם תרצה להפעיל?*</div>
          <div class="add_new_row_col2">
            <div
              class="input-opacity desk-block"
              :class="{ disabled: !surgery.insurance_type }"
            >
              <validation-provider
                name="payType"
                rules="required"
                v-slot="{ errors }"
              >
                <select2
                  dir="rtl"
                  v-model="localPayType"
                  :disabled="!surgery.insurance_type"
                >
                  <option
                    v-for="option in payOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select2>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>

        <!-- Insurance Company Details (shown when insured) -->
        <template v-if="surgery.isInsuranceCompany === 'true'">
          <div class="add_new_row flex">
            <div class="add_new_row_col1">באיזו חברת ביטוח?*</div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <validation-provider
                  name="insuranceCompany"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <select2 dir="rtl" v-model="surgery.insuranceCompany">
                    <option
                      v-for="option in insuranceQuestions.insuranceCompanyOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </select2>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>

          <!-- Insurance Claim Handling (shown when pay type is insurance company) -->
          <div v-if="localPayType === 'חברת ביטוח'" class="add_new_row flex">
            <div class="add_new_row_col1">
              מעוניין שבית החולים יפנה בשמך לחברת הביטוח?*
            </div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <input
                  v-if="localPayType !== 'חברת ביטוח'"
                  type="text"
                  placeholder=""
                  disabled
                />
                <validation-provider
                  v-else
                  name="insuranceClaim"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <select2
                    dir="rtl"
                    v-model="surgery.handle_insurance_claim_by_hmc"
                  >
                    <option value="">בחר</option>
                    <option value="approved">כן</option>
                    <option value="denied">לא</option>
                  </select2>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
        </template>

        <!-- Doctor Fee Required (shown when pay type is insurance company) -->
        <div v-if="localPayType === 'חברת ביטוח'" class="add_new_row flex">
          <div class="add_new_row_col1">האם לגבות שכר טרחה?*</div>
          <div class="add_new_row_col2">
            <div
              class="input-opacity"
              :class="{
                disabled: !localPayType || isPayTypeCareService
              }"
            >
              <validation-provider
                name="isPayRequired"
                :rules="!localPayType || isPayTypeCareService ? '' : 'required'"
                v-slot="{ errors }"
              >
                <select2
                  dir="rtl"
                  v-model="localIsPayRequired"
                  :disabled="!localPayType || isPayTypeCareService"
                >
                  <option
                    v-for="option in insuranceQuestions.booleanOptions"
                    :key="option.text"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select2>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>

        <!-- Doctor Fee Amount -->
        <div
          v-if="
            localIsPayRequired === 'true' ||
              localPayType === 'פרטי' ||
              isRHINOPLASTYSurgery
          "
          class="add_new_row flex"
        >
          <div class="add_new_row_col1">
            שכר טרחה
            <span class="note mobile_only">
              שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)
            </span>
          </div>
          <div class="add_new_row_col2">
            <div class="input-opacity">
              <input
                type="tel"
                v-mask="'#'.repeat(10)"
                v-model="surgery.doctor_fee"
                placeholder="₪"
                autocomplete="off"
                :disabled="
                  (!localPayType || isPayTypeCareService) &&
                    !isRHINOPLASTYSurgery
                "
              />
            </div>
            <span class="note no_mobile">
              שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";
import { insuranceQuestions } from "@/utilities/surgery-questions.js";

export default {
  name: "InsuranceDetails",
  components: {
    Tags
  },
  data() {
    return {
      isOpen: true,
      insuranceQuestions
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      insuranceForm: state => state.insuranceForm,
      insuranceSurgeryTemp: state => state.insuranceSurgeryTemp
    }),
    ...mapGetters("Surgery", ["isPayTypeCareService", "isRHINOPLASTYSurgery"]),

    /**
     * Local payType with two-way binding to store
     */
    localPayType: {
      get() {
        return this.insuranceForm.payType;
      },
      set(value) {
        this.SET_INSURANCE_FORM({ payType: value });
      }
    },

    /**
     * Local isPayRequired with two-way binding to store
     */
    localIsPayRequired: {
      get() {
        return this.insuranceForm.isPayRequired;
      },
      set(value) {
        this.SET_INSURANCE_FORM({ isPayRequired: value });
      }
    },

    /**
     * Determines available pay options based on insurance type and company status
     */
    payOptions() {
      const insuranceTypeOptions = {
        כללית: this.insuranceQuestions.clalitOptions,
        מאוחדת: this.insuranceQuestions.meohedetOptions,
        מכבי: this.insuranceQuestions.macabiOptions,
        לאומית: this.insuranceQuestions.leumitOptions
      };

      let filteredPayOptions = insuranceTypeOptions[
        this.surgery.insurance_type
      ] || [{ text: "בחר", value: "" }];

      let payOptions = this.insuranceQuestions.payOptions;

      // Remove insurance company option if not insured
      if (this.surgery.isInsuranceCompany === "false") {
        filteredPayOptions = filteredPayOptions.filter(
          item => item.value !== "חברת ביטוח"
        );
        payOptions = payOptions.filter(item => item.value !== "חברת ביטוח");
      }

      return [
        ...filteredPayOptions,
        ...(this.surgery.insurance_type !== "כללית" ? payOptions : [])
      ];
    }
  },
  watch: {
    /**
     * Reset insurance fields when insurance company status changes
     */
    "surgery.isInsuranceCompany"(val, prevVal) {
      if (val === prevVal || !prevVal) return;
      this.SET_INSURANCE_FORM({ payType: "", isPayRequired: "" });
      this.SET_SURGERY({
        doctor_fee: "",
        insuranceCompany: "",
        handle_insurance_claim_by_hmc: ""
      });
      this.handleSpecialInsuranceReset();
    },

    /**
     * Handle pay type changes - reset related fields and fetch insurance data
     */
    async localPayType(val) {
      if (!val || this.isPayTypeCareService) {
        this.SET_SURGERY({ doctor_fee: "" });
      }
      if (val !== "חברת ביטוח") {
        this.SET_INSURANCE_FORM({ isPayRequired: "" });
        this.SET_SURGERY({ handle_insurance_claim_by_hmc: "" });
      }
      if (val !== "חברת ביטוח" && val !== "פרטי") {
        this.SET_SURGERY({ doctor_fee: "" });
      }
      // Fetch insurance surgery codes when pay type changes
      await this.getDataAfterPayTypeChanged(val);
    },

    /**
     * Reset pay type when insurance type changes
     */
    "surgery.insurance_type"(val, prevVal) {
      if (val === prevVal || !prevVal) return;
      this.SET_INSURANCE_FORM({ payType: "" });
      this.SET_SURGERY({
        doctor_fee: "",
        handle_insurance_claim_by_hmc: ""
      });
    }
  },
  methods: {
    ...mapMutations("Surgery", [
      "SET_SURGERY",
      "SET_INSURANCE_FORM",
      "UPDATE_INSURANCE_SURGERY_TEMP_ITEM"
    ]),
    ...mapActions("Surgery", ["getDataAfterPayTypeChanged"]),

    /**
     * Handles reset of special insurance codes in temp array
     */
    handleSpecialInsuranceReset() {
      const foundIndex = this.insuranceSurgeryTemp.findIndex(
        s => s?.code_name_hospital === "1 > RHINOPLASTY"
      );
      if (foundIndex !== -1) {
        this.UPDATE_INSURANCE_SURGERY_TEMP_ITEM({
          index: foundIndex,
          data: {
            insurance_type: "",
            insurance_surgery_codes: []
          }
        });
      }
    }
  }
};
</script>
